export function selectDarkmode(state) {
  return state.ThemeReducer.darkmode;
}
export function selectDarkmodeSettings(state) {
  return { ...state.ThemeReducer.darkmodeConfig };
}
export function selectLightmodeSettings(state) {
  return { ...state.ThemeReducer.lightmodeConfig };
}
